export const LABELS = {
  TITLE: 'Agents we partner with',
  SUBTITLE: 'Trusted by the industry. These are just some of the many agencies we partner with.',
  BUTTON: 'Apply now',
};
